import React from "react";

import {
  Empty,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "../shadcn/components/ui/empty";
import { Spinner } from "../shadcn/components/ui/spinner";
import { useTranslation } from "../context/Internationalization";
import { cn } from "../shadcn/lib/utils";

// Loading screen: the shadcn "Empty with spinner" pattern. `fullPage` fills
// the window (sign-in, redirects); otherwise it fills the page area.
const Loader = ({ message, fullPage = false }) => {
  const { t } = useTranslation();
  const label = message || t?.("loading");

  return (
    <main
      aria-busy="true"
      aria-live="polite"
      className={cn(
        "flex grow text-foreground",
        fullPage ? "min-h-screen" : "h-full"
      )}
    >
      <Empty className="border-0">
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <Spinner aria-label={label} />
          </EmptyMedia>
          {message ? (
            <EmptyTitle className="text-base font-normal">{message}</EmptyTitle>
          ) : null}
        </EmptyHeader>
      </Empty>
    </main>
  );
};

export default Loader;
